import { render } from "./InitiatorFields.vue?vue&type=template&id=c4a390e6"
import script from "./InitiatorFields.vue?vue&type=script&lang=js"
export * from "./InitiatorFields.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__